import ProfileSuccessPage from './profile-success-page';

export default ProfileSuccessPage;
